import React, { useState, useEffect } from 'react';
import AiSpkUpgradeModal from "component/Modal/AiSpkUpgradeModal";
import Login from "component/user/Login";

import { useSelector } from "react-redux";
import useLoginStatus from "../../common/hook/useLoginStatus";
import { ModalContext } from "../../component/Modal/modalContext";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const AISpeak2Page = () => {
    let { handleModal } = React.useContext(ModalContext);


    const isLogin = useLoginStatus();
    const { data: UserData } = useSelector((state) => state.user);
    const history = useHistory();
    const location = useLocation();

    const domain = "https://aispeak2.masterkorea.com";
    const popupURL = domain + "/waiting";


    const openLoginModal = () => {
        history.replace('/');
        handleModal(<Login />, false, 420, location.pathname);
    };

    const openAiSpkUpgradeModal = () => {
        history.replace('/');
        handleModal(<AiSpkUpgradeModal />, false, 460);
    };

    const handleLoginValidation = () => {
        if (isLogin) {
            if (UserData.serviceLevel === "STANDARD" || UserData.serviceLevel === "PREMIUM") {
                const popupOption = `width=${window.innerWidth}, height=${window.innerHeight}, top=0, left=0, location=no, toolbars=no, status=no`;
                // 페이지가 로드되면 팝업 열기
                const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
                history.replace('/');

                window.open(popupURL, JSON.stringify(storedUserInfo, null, 3), popupOption);
            }else{
                openAiSpkUpgradeModal();
            }
        } else {
            openLoginModal();
        }
    };


    useEffect(() => {

        const userInfo = {
            email: UserData.userIdx,
            mberNm: UserData.fullName,
            acadCd: 'KR-MT-000001',
        };
        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        handleLoginValidation();


    }, []); // 빈 배열을 넣어서 컴포넌트가 처음 마운트될 때만 실행되도록 함

    return (
        <div>

        </div>
    );
};

export default AISpeak2Page;
